(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $cc0e491931e0ba58$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $cc0e491931e0ba58$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $cc0e491931e0ba58$var$argsTag = '[object Arguments]', $cc0e491931e0ba58$var$funcTag = '[object Function]', $cc0e491931e0ba58$var$genTag = '[object GeneratorFunction]';
/** Used to detect unsigned integer values. */ var $cc0e491931e0ba58$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $cc0e491931e0ba58$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $cc0e491931e0ba58$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $cc0e491931e0ba58$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $cc0e491931e0ba58$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cc0e491931e0ba58$var$hasOwnProperty = $cc0e491931e0ba58$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cc0e491931e0ba58$var$objectToString = $cc0e491931e0ba58$var$objectProto.toString;
/** Built-in value references. */ var $cc0e491931e0ba58$var$propertyIsEnumerable = $cc0e491931e0ba58$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cc0e491931e0ba58$var$nativeKeys = $cc0e491931e0ba58$var$overArg(Object.keys, Object), $cc0e491931e0ba58$var$nativeMax = Math.max;
/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */ var $cc0e491931e0ba58$var$nonEnumShadows = !$cc0e491931e0ba58$var$propertyIsEnumerable.call({
    'valueOf': 1
}, 'valueOf');
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $cc0e491931e0ba58$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $cc0e491931e0ba58$var$isArray(value) || $cc0e491931e0ba58$var$isArguments(value) ? $cc0e491931e0ba58$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $cc0e491931e0ba58$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $cc0e491931e0ba58$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $cc0e491931e0ba58$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($cc0e491931e0ba58$var$hasOwnProperty.call(object, key) && $cc0e491931e0ba58$var$eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cc0e491931e0ba58$var$baseKeys(object) {
    if (!$cc0e491931e0ba58$var$isPrototype(object)) return $cc0e491931e0ba58$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($cc0e491931e0ba58$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $cc0e491931e0ba58$var$baseRest(func, start) {
    start = $cc0e491931e0ba58$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $cc0e491931e0ba58$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return $cc0e491931e0ba58$var$apply(func, this, otherArgs);
    };
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $cc0e491931e0ba58$var$copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        $cc0e491931e0ba58$var$assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $cc0e491931e0ba58$var$createAssigner(assigner) {
    return $cc0e491931e0ba58$var$baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $cc0e491931e0ba58$var$isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $cc0e491931e0ba58$var$isIndex(value, length) {
    length = length == null ? $cc0e491931e0ba58$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $cc0e491931e0ba58$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $cc0e491931e0ba58$var$isIterateeCall(value, index, object) {
    if (!$cc0e491931e0ba58$var$isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $cc0e491931e0ba58$var$isArrayLike(object) && $cc0e491931e0ba58$var$isIndex(index, object.length) : type == 'string' && index in object) return $cc0e491931e0ba58$var$eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $cc0e491931e0ba58$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $cc0e491931e0ba58$var$objectProto;
    return value === proto;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $cc0e491931e0ba58$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $cc0e491931e0ba58$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $cc0e491931e0ba58$var$isArrayLikeObject(value) && $cc0e491931e0ba58$var$hasOwnProperty.call(value, 'callee') && (!$cc0e491931e0ba58$var$propertyIsEnumerable.call(value, 'callee') || $cc0e491931e0ba58$var$objectToString.call(value) == $cc0e491931e0ba58$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $cc0e491931e0ba58$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $cc0e491931e0ba58$var$isArrayLike(value) {
    return value != null && $cc0e491931e0ba58$var$isLength(value.length) && !$cc0e491931e0ba58$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $cc0e491931e0ba58$var$isArrayLikeObject(value) {
    return $cc0e491931e0ba58$var$isObjectLike(value) && $cc0e491931e0ba58$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cc0e491931e0ba58$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $cc0e491931e0ba58$var$isObject(value) ? $cc0e491931e0ba58$var$objectToString.call(value) : '';
    return tag == $cc0e491931e0ba58$var$funcTag || tag == $cc0e491931e0ba58$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $cc0e491931e0ba58$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $cc0e491931e0ba58$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cc0e491931e0ba58$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cc0e491931e0ba58$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $cc0e491931e0ba58$var$assign = $cc0e491931e0ba58$var$createAssigner(function(object, source) {
    if ($cc0e491931e0ba58$var$nonEnumShadows || $cc0e491931e0ba58$var$isPrototype(source) || $cc0e491931e0ba58$var$isArrayLike(source)) {
        $cc0e491931e0ba58$var$copyObject(source, $cc0e491931e0ba58$var$keys(source), object);
        return;
    }
    for(var key in source)if ($cc0e491931e0ba58$var$hasOwnProperty.call(source, key)) $cc0e491931e0ba58$var$assignValue(object, key, source[key]);
});
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $cc0e491931e0ba58$var$keys(object) {
    return $cc0e491931e0ba58$var$isArrayLike(object) ? $cc0e491931e0ba58$var$arrayLikeKeys(object) : $cc0e491931e0ba58$var$baseKeys(object);
}
$cc0e491931e0ba58$exports = $cc0e491931e0ba58$var$assign;


function $ee6181f170cdcfff$var$_extends() {
    return $ee6181f170cdcfff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ee6181f170cdcfff$var$_extends.apply(null, arguments);
}
const { createHigherOrderComponent: $ee6181f170cdcfff$var$createHigherOrderComponent } = wp.compose;
const { Fragment: $ee6181f170cdcfff$var$Fragment } = wp.element;
const { BlockControls: $ee6181f170cdcfff$var$BlockControls } = wp.blockEditor;
const { Toolbar: $ee6181f170cdcfff$var$Toolbar, IconButton: $ee6181f170cdcfff$var$IconButton } = wp.components;
const { addFilter: $ee6181f170cdcfff$var$addFilter } = wp.hooks;
const { __: $ee6181f170cdcfff$var$__ } = wp.i18n;
// Blocks that are not compatible at all with visibility controls.
const $ee6181f170cdcfff$var$globallyRestricted = [
    'core/freeform',
    'core/legacy-widget',
    'core/widget-area'
];
/**
 * Add layout control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @returns {object} Modified block settings.
 */ const $ee6181f170cdcfff$var$addDisableBlockControlAttribute = (settings, name)=>{
    // The freeform (Classic Editor) block is incompatible because it does not
    // support custom attributes.
    if ($ee6181f170cdcfff$var$globallyRestricted.includes(settings.name)) return settings;
    if (typeof settings.attributes !== 'undefined') {
        const attributes = {
            disableBlock: {
                type: 'boolean',
                default: false
            }
        };
        // Use Lodash's assign to gracefully handle if attributes are undefined
        settings.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($cc0e491931e0ba58$exports)))(settings.attributes, attributes);
        settings.supports = (0, (/*@__PURE__*/$parcel$interopDefault($cc0e491931e0ba58$exports)))(settings.supports, {
            disableBlock: false
        });
    }
    return settings;
};
$ee6181f170cdcfff$var$addFilter('blocks.registerBlockType', 'disableBlock/attribute', $ee6181f170cdcfff$var$addDisableBlockControlAttribute);
/**
 * Create HOC to add layout control to inspector controls of block.
 */ const $ee6181f170cdcfff$var$withLogicControl = $ee6181f170cdcfff$var$createHigherOrderComponent((BlockEdit)=>{
    return (props)=>{
        const { attributes: attributes, setAttributes: setAttributes, isSelected: isSelected } = props;
        const { disableBlock: disableBlock } = attributes;
        if (disableBlock) attributes.disableBlock = disableBlock;
        return React.createElement($ee6181f170cdcfff$var$Fragment, null, React.createElement(BlockEdit, props), isSelected && !$ee6181f170cdcfff$var$globallyRestricted.includes(props.name) && React.createElement($ee6181f170cdcfff$var$BlockControls, null, React.createElement($ee6181f170cdcfff$var$Toolbar, null, React.createElement($ee6181f170cdcfff$var$IconButton, {
            label: attributes.disableBlock ? $ee6181f170cdcfff$var$__('Enable Block', 'disable-block') : $ee6181f170cdcfff$var$__('Disable Block', 'disable-block'),
            icon: attributes.disableBlock ? 'hidden' : 'visibility',
            onClick: ()=>{
                const newValue = !attributes.disableBlock;
                setAttributes({
                    disableBlock: newValue
                });
                // Trigger sync after a slight delay to let React update the DOM
                setTimeout(()=>{
                    $ee6181f170cdcfff$var$addDataAttributeToListView();
                }, 200);
            }
        }))));
    };
}, 'withLogicControl');
$ee6181f170cdcfff$var$addFilter('editor.BlockEdit', 'disableBlock/control', $ee6181f170cdcfff$var$withLogicControl);
// add a data attribute to the block wrapper "editor-block-list__block"
// this hook only fires for the BE/Admin View
const $ee6181f170cdcfff$var$addWrapperDataAttribute = $ee6181f170cdcfff$var$createHigherOrderComponent((BlockListBlock)=>{
    return (props)=>{
        const { disableBlock: disableBlock } = props.attributes;
        const { name: name } = props.block;
        let newName = name.replace(/\w+\//gm, '');
        newName = newName.charAt(0).toUpperCase() + newName.slice(1);
        let wrapperProps = props.wrapperProps;
        let customData = {};
        if (typeof disableBlock !== 'undefined' && disableBlock) customData = (0, (/*@__PURE__*/$parcel$interopDefault($cc0e491931e0ba58$exports)))(customData, {
            'data-spk-block-disabled': $ee6181f170cdcfff$var$__('Block', 'disable-block') + ' ' + newName + ' ' + $ee6181f170cdcfff$var$__('is disabled', 'disable-block')
        });
        wrapperProps = (0, (/*@__PURE__*/$parcel$interopDefault($cc0e491931e0ba58$exports)))(wrapperProps, customData);
        return React.createElement(BlockListBlock, $ee6181f170cdcfff$var$_extends({}, props, {
            wrapperProps: wrapperProps
        }));
    };
}, 'addWrapperDataAttribute');
$ee6181f170cdcfff$var$addFilter('editor.BlockListBlock', 'disableBlock/addWrapperDataAttribute', $ee6181f170cdcfff$var$addWrapperDataAttribute);
const $ee6181f170cdcfff$var$addDataAttributeToListView = ()=>{
    const { select: select } = wp.data;
    const allBlocks = select('core/block-editor').getBlocks();
    const seenClientIds = new Set();
    allBlocks.forEach((block)=>{
        const blockId = block.clientId;
        const listViewRow = document.querySelector(`.block-editor-list-view-leaf[data-block="${blockId}"]`);
        if (!listViewRow) return;
        seenClientIds.add(blockId);
        if (block.attributes.disableBlock) listViewRow.setAttribute('data-spk-block-disabled', 'true');
        else listViewRow.removeAttribute('data-spk-block-disabled');
    });
    // Optional: Clean up orphaned attributes if blocks were removed
    const allListRows = document.querySelectorAll('.block-editor-list-view-leaf[data-spk-block-disabled]');
    allListRows.forEach((row)=>{
        const blockId = row.getAttribute('data-block');
        if (!seenClientIds.has(blockId)) row.removeAttribute('data-spk-block-disabled');
    });
};
let $ee6181f170cdcfff$var$observer = null;
const $ee6181f170cdcfff$var$setupBodyContainerObserver = ()=>{
    if ($ee6181f170cdcfff$var$observer) return; // Already observing
    $ee6181f170cdcfff$var$observer = new MutationObserver(()=>{
        const leafs = document.querySelectorAll('.block-editor-list-view-leaf');
        if (leafs.length > 0) $ee6181f170cdcfff$var$addDataAttributeToListView();
    });
    $ee6181f170cdcfff$var$observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};
window.addEventListener('load', ()=>{
    $ee6181f170cdcfff$var$setupBodyContainerObserver();
});

})();
//# sourceMappingURL=disable-block.js.map
